import { render, staticRenderFns } from "./BulkDisputeModal.vue?vue&type=template&id=20b66bda&scoped=true"
import script from "./BulkDisputeModal.vue?vue&type=script&lang=js"
export * from "./BulkDisputeModal.vue?vue&type=script&lang=js"
import style0 from "./BulkDisputeModal.vue?vue&type=style&index=0&id=20b66bda&prod&lang=scss&scoped=true"
import style1 from "./BulkDisputeModal.vue?vue&type=style&index=1&id=20b66bda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b66bda",
  null
  
)

export default component.exports